define('catalogEntities',[
  'app',
  'jquery',
  'backbone',
  'underscore',
  'settings',
  'backboneRelational',
  'entities/dynamic_text'
], function (
  App,
  $,
  Backbone,
  _,
  Settings
) {
  'use strict';

  var app;
  if (Backbone.Relational.store._modelScopes && Backbone.Relational.store._modelScopes.length > 0) {
    app = {ns: Backbone.Relational.store._modelScopes[0]};
  } else {
    app = {ns: {}};
    Backbone.Relational.store.addModelScope(app.ns);
  }

  // Models
  app.ns.Catalog = Backbone.RelationalModel.extend({
    idAttribute: 'secId',
    relations: [{
      type: Backbone.HasOne,
      key: 'name',
      relatedModel: 'DynamicText'
    }],
    getId: function () {
      return this.get('secId');
    },
    getName: function (lang) {
      var name = this.get('name') || {};
      var l = lang || Settings.get('lang');
      // If relation resolved to a model
      if (name && _.isFunction(name.getTextInLocale)) {
        return name.getTextInLocale(l);
      }
      // Support DynamicText structure { values: { en: '...', fr: '...' } }
      if (name && name.values) {
        return name.values[l] || name.values.en || name.values.fr || '';
      }
      // Backward compatibility: plain map { en: '...', fr: '...' }
      return name[l] || name.en || name.fr || '';
    },
    url: function () {
      var base = 'v2/catalog/definitions';
      if (this.isNew()) return Settings.url('compuzz2', base);
      return Settings.url('compuzz2', base + '/' + encodeURIComponent(this.getId()));
    }
  });

  app.ns.CatalogTemplate = Backbone.RelationalModel.extend({
    idAttribute: 'secId',
    relations: [{
      type: Backbone.HasOne,
      key: 'content',
      relatedModel: 'DynamicText'
    }],
    getId: function () { return this.get('secId'); },
    getContent: function (lang) {
      var content = this.get('content') || {};
      var l = lang || Settings.get('lang');
      if (content && _.isFunction(content.getTextInLocale)) {
        return content.getTextInLocale(l);
      }
      if (content && content.values) {
        return content.values[l] || content.values.en || content.values.fr || '';
      }
      return content[l] || content.en || content.fr || '';
    },
    url: function () {
      // Needs catalogSecId on the model to build URL
      var catalogSecId = this.get('catalogSecId') || this.collection && this.collection.catalogSecId;
      var base = 'v2/catalog/definitions/' + encodeURIComponent(catalogSecId) + '/templates';
      if (this.isNew()) return Settings.url('compuzz2', base);
      return Settings.url('compuzz2', base + '/' + encodeURIComponent(this.getId()));
    }
  });

  // API helpers
  // Normalize dynamic text payloads to { values: {..} }
  function normalizeDynamicText(dt) {
    if (!dt) return { values: {} };
    // Already in new format
    if (dt.values) return dt;
    // If came as plain map of locales, wrap it
    return { values: _.clone(dt) };
  }

  var API = {
    catalogs: {
      list: function () {
        var defer = $.Deferred();
        $.ajax({
          type: 'GET',
          url: Settings.url('compuzz2', 'v2/catalog/definitions'),
          success: function (items) {
            // Use findOrCreate to avoid duplicate relational models with same id
            var models = _.map(items || [], function (it) { return app.ns.Catalog.findOrCreate(it || {}); });
          defer.resolve(models);
          },
          error: function (xhr) { defer.reject(xhr); }
        });
        return defer.promise();
      },
      create: function (data) {
        var defer = $.Deferred();
        data = data || {};
        if (data.name) data.name = normalizeDynamicText(data.name);
        $.ajax({
          type: 'POST',
          url: Settings.url('compuzz2', 'v2/catalog/definitions'),
          data: JSON.stringify(data),
          processData: false,
          contentType: 'application/json',
          success: function (item) { defer.resolve(app.ns.Catalog.findOrCreate(item || {})); },
          error: function (xhr) { defer.reject(xhr); }
        });
        return defer.promise();
      },
      update: function (secId, data) {
        var defer = $.Deferred();
        data = data || {};
        if (data.name) data.name = normalizeDynamicText(data.name);
        $.ajax({
          type: 'PUT',
          url: Settings.url('compuzz2', 'v2/catalog/definitions/' + encodeURIComponent(secId)),
          data: JSON.stringify(data),
          processData: false,
          contentType: 'application/json',
          success: function (item) { defer.resolve(app.ns.Catalog.findOrCreate(item || {})); },
          error: function (xhr) { defer.reject(xhr); }
        });
        return defer.promise();
      },
      remove: function (secId) {
        var defer = $.Deferred();
        $.ajax({
          type: 'DELETE',
          url: Settings.url('compuzz2', 'v2/catalog/definitions/' + encodeURIComponent(secId)),
          success: function () { defer.resolve(); },
          error: function (xhr) { defer.reject(xhr); }
        });
        return defer.promise();
      }
    },
    templates: {
      list: function (catalogSecId) {
        var defer = $.Deferred();
        $.ajax({
          type: 'GET',
          url: Settings.url('compuzz2', 'v2/catalog/definitions/' + encodeURIComponent(catalogSecId) + '/templates'),
          success: function (items) {
            var models = _.map(items || [], function (it) {
              it = it || {};
              it.catalogSecId = catalogSecId;
              return app.ns.CatalogTemplate.findOrCreate(it);
            });
            defer.resolve(models);
          },
          error: function (xhr) { defer.reject(xhr); }
        });
        return defer.promise();
      },
      create: function (catalogSecId, data) {
        var defer = $.Deferred();
        data = data || {};
        if (data.content) data.content = normalizeDynamicText(data.content);
        $.ajax({
          type: 'POST',
          url: Settings.url('compuzz2', 'v2/catalog/definitions/' + encodeURIComponent(catalogSecId) + '/templates'),
          data: JSON.stringify(data),
          processData: false,
          contentType: 'application/json',
          success: function (item) { item = item || {}; item.catalogSecId = catalogSecId; defer.resolve(app.ns.CatalogTemplate.findOrCreate(item)); },
          error: function (xhr) { defer.reject(xhr); }
        });
        return defer.promise();
      },
      update: function (catalogSecId, secId, data) {
        var defer = $.Deferred();
        data = data || {};
        if (data.content) data.content = normalizeDynamicText(data.content);
        $.ajax({
          type: 'PUT',
          url: Settings.url('compuzz2', 'v2/catalog/definitions/' + encodeURIComponent(catalogSecId) + '/templates/' + encodeURIComponent(secId)),
          data: JSON.stringify(data),
          processData: false,
          contentType: 'application/json',
          success: function (item) { item = item || {}; item.catalogSecId = catalogSecId; defer.resolve(app.ns.CatalogTemplate.findOrCreate(item)); },
          error: function (xhr) { defer.reject(xhr); }
        });
        return defer.promise();
      },
      remove: function (catalogSecId, secId) {
        var defer = $.Deferred();
        $.ajax({
          type: 'DELETE',
          url: Settings.url('compuzz2', 'v2/catalog/definitions/' + encodeURIComponent(catalogSecId) + '/templates/' + encodeURIComponent(secId)),
          success: function () { defer.resolve(); },
          error: function (xhr) { defer.reject(xhr); }
        });
        return defer.promise();
      }
    }
  };

  // Req/Res handlers
  App.reqres.setHandler('catalogs:list', function () {
    return API.catalogs.list();
  });
  App.reqres.setHandler('catalog:model', function (data) {
    return app.ns.Catalog.findOrCreate(data || {});
  });
  App.reqres.setHandler('catalog:create', function (data) {
    return API.catalogs.create(data);
  });
  App.reqres.setHandler('catalog:update', function (secId, data) {
    return API.catalogs.update(secId, data);
  });
  App.reqres.setHandler('catalog:delete', function (secId) {
    return API.catalogs.remove(secId);
  });

  App.reqres.setHandler('catalog.templates:list', function (catalogSecId) {
    return API.templates.list(catalogSecId);
  });
  App.reqres.setHandler('catalog.template:create', function (catalogSecId, data) {
    return API.templates.create(catalogSecId, data);
  });
  App.reqres.setHandler('catalog.template:update', function (catalogSecId, secId, data) {
    return API.templates.update(catalogSecId, secId, data);
  });
  App.reqres.setHandler('catalog.template:delete', function (catalogSecId, secId) {
    return API.templates.remove(catalogSecId, secId);
  });
});

